import { apiClient } from '@app/lib'
import { type SugarAttestationPeriodsPaginatedResponse } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const useAttestationPeriods = (schoolYearId?: string | null) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated' && !!schoolYearId,
    queryKey: ['attestationPeriods', { schoolYearId }],
    queryFn: async () => {
      const { data } = await apiClient.get<SugarAttestationPeriodsPaginatedResponse>('/api/attestation-periods', {
        params: {
          schoolYearId
        }
      })

      return data
    }
  })
}
